import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

// CATEGORIES

export const FETCH_CATEGORIES_BEGIN = "FETCH_CATEGORIES_BEGIN"
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS"
export const FETCH_CATEGORIES_ERROR = "FETCH_CATEGORIES_ERROR"

export const fetchCategoriesBegin = () => ({
	type: FETCH_CATEGORIES_BEGIN,
})

export const fetchCategoriesSuccess = (categories) => ({
	type: FETCH_CATEGORIES_SUCCESS,
	payload: { categories },
})

export const fetchCategoriesError = (error) => ({
	type: FETCH_CATEGORIES_ERROR,
	payload: { error },
})

export function fetchCategories(id = null) {
	let url = `${URL}api/categories${id != null ? `?id=${id}` : ""}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchCategoriesBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchCategoriesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchCategoriesError))
	}
}

export const FETCH_CATEGORIES_TRI_BEGIN = "FETCH_CATEGORIES_TRI_BEGIN"
export const FETCH_CATEGORIES_TRI_SUCCESS = "FETCH_CATEGORIES_TRI_SUCCESS"
export const FETCH_CATEGORIES_TRI_ERROR = "FETCH_CATEGORIES_TRI_ERROR"

export const fetchCategoriesTriBegin = () => ({
	type: FETCH_CATEGORIES_TRI_BEGIN,
})

export const fetchCategoriesTriSuccess = (categories) => ({
	type: FETCH_CATEGORIES_TRI_SUCCESS,
	payload: { categories },
})

export const fetchCategoriesTriError = (error) => ({
	type: FETCH_CATEGORIES_TRI_ERROR,
	payload: { error },
})

export function fetchCategoriesTri(type) {
	let url = `${URL}api/categories?type=${type}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchCategoriesTriBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchCategoriesTriSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchCategoriesTriError))
	}
}

export const POST_CATEGORIES_BEGIN = "POST_CATEGORIES_BEGIN"
export const POST_CATEGORIES_SUCCESS = "POST_CATEGORIES_SUCCESS"
export const POST_CATEGORIES_ERROR = "POST_CATEGORIES_ERROR"
export const POST_CATEGORIES_RESET = "POST_CATEGORIES_RESET"

export const postCategoriesBegin = () => ({
	type: POST_CATEGORIES_BEGIN,
})

export const postCategoriesSuccess = (categories) => ({
	type: POST_CATEGORIES_SUCCESS,
	payload: { categories },
})

export const postCategoriesError = (error) => ({
	type: POST_CATEGORIES_ERROR,
	payload: { error },
})

export const postCategoriesReset = () => ({
	type: POST_CATEGORIES_RESET,
})

export function postCategories(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postCategoriesBegin())
		return fetch(`${URL}api/categories`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postCategoriesSuccess(json))
			})
			.then(() => dispatch(fetchItemChecker()))
			.catch(catchApiError(dispatch, postCategoriesError))
	}
}

// SOUS-CATEGORIES

export const FETCH_LOTS_BEGIN = "FETCH_LOTS_BEGIN"
export const FETCH_LOTS_SUCCESS = "FETCH_LOTS_SUCCESS"
export const FETCH_LOTS_ERROR = "FETCH_LOTS_ERROR"

export const fetchLotsBegin = () => ({
	type: FETCH_LOTS_BEGIN,
})

export const fetchLotsSuccess = (lots) => ({
	type: FETCH_LOTS_SUCCESS,
	payload: { lots },
})

export const fetchLotsError = (error) => ({
	type: FETCH_LOTS_ERROR,
	payload: { error },
})

export function fetchLots(id = null) {
	let url = `${URL}api/lots${id != null ? `?id=${id}` : ""}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchLotsBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchLotsSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchLotsError))
	}
}

export const POST_LOTS_BEGIN = "POST_LOTS_BEGIN"
export const POST_LOTS_SUCCESS = "POST_LOTS_SUCCESS"
export const POST_LOTS_ERROR = "POST_LOTS_ERROR"
export const POST_LOTS_RESET = "POST_LOTS_RESET"

export const postLotsBegin = () => ({
	type: POST_LOTS_BEGIN,
})

export const postLotsSuccess = (lots) => ({
	type: POST_LOTS_SUCCESS,
	payload: { lots },
})

export const postLotsError = (error) => ({
	type: POST_LOTS_ERROR,
	payload: { error },
})

export const postLotsReset = () => ({
	type: POST_LOTS_RESET,
})

export function postLots(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postLotsBegin())
		return fetch(`${URL}api/lots`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postLotsSuccess(json))
			})
			.then(() => dispatch(fetchItemChecker()))
			.catch(catchApiError(dispatch, postLotsError))
	}
}

// ITEM

export const FETCH_ITEMS_BEGIN = "FETCH_ITEMS_BEGIN"
export const FETCH_ITEMS_SUCCESS = "FETCH_ITEMS_SUCCESS"
export const FETCH_ITEMS_ERROR = "FETCH_ITEMS_ERROR"

export const fetchItemsBegin = () => ({
	type: FETCH_ITEMS_BEGIN,
})

export const fetchItemsSuccess = (items) => ({
	type: FETCH_ITEMS_SUCCESS,
	payload: { items },
})

export const fetchItemsError = (error) => ({
	type: FETCH_ITEMS_ERROR,
	payload: { error },
})

export function fetchItems(id = null) {
	let url = `${URL}api/items${id != null ? `?id=${id}` : ""}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchItemsBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchItemsSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchItemsError))
	}
}

export const POST_ITEMS_BEGIN = "POST_ITEMS_BEGIN"
export const POST_ITEMS_SUCCESS = "POST_ITEMS_SUCCESS"
export const POST_ITEMS_ERROR = "POST_ITEMS_ERROR"
export const POST_ITEMS_RESET = "POST_ITEMS_RESET"

export const postItemsBegin = () => ({
	type: POST_ITEMS_BEGIN,
})

export const postItemsSuccess = (items) => ({
	type: POST_ITEMS_SUCCESS,
	payload: { items },
})

export const postItemsError = (error) => ({
	type: POST_ITEMS_ERROR,
	payload: { error },
})

export function postItems(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postItemsBegin())
		return fetch(`${URL}api/items`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postItemsSuccess(json))
			})
			.catch(catchApiError(dispatch, postItemsError))
	}
}

// LOT USAGE

export const FETCH_LOTUSAGES_BEGIN = "FETCH_LOTUSAGES_BEGIN"
export const FETCH_LOTUSAGES_SUCCESS = "FETCH_LOTUSAGES_SUCCESS"
export const FETCH_LOTUSAGES_ERROR = "FETCH_LOTUSAGES_ERROR"

export const fetchLotUsagesBegin = () => ({
	type: FETCH_LOTUSAGES_BEGIN,
})

export const fetchLotUsagesSuccess = (lotUsages) => ({
	type: FETCH_LOTUSAGES_SUCCESS,
	payload: { lotUsages },
})

export const fetchLotUsagesError = (error) => ({
	type: FETCH_LOTUSAGES_ERROR,
	payload: { error },
})

export function fetchLotUsages(id = null) {
	let url = `${URL}api/lotusages${id != null ? `?id=${id}` : ""}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchLotUsagesBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchLotUsagesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchLotUsagesError))
	}
}

export const POST_LOTUSAGES_BEGIN = "POST_LOTUSAGES_BEGIN"
export const POST_LOTUSAGES_SUCCESS = "POST_LOTUSAGES_SUCCESS"
export const POST_LOTUSAGES_ERROR = "POST_LOTUSAGES_ERROR"
export const POST_LOTUSAGES_RESET = "POST_LOTUSAGES_RESET"

export const postLotUsagesBegin = () => ({
	type: POST_LOTUSAGES_BEGIN,
})

export const postLotUsagesSuccess = (sousCategories) => ({
	type: POST_LOTUSAGES_SUCCESS,
	payload: { sousCategories },
})

export const postLotUsagesError = (error) => ({
	type: POST_LOTUSAGES_ERROR,
	payload: { error },
})

export function postLotUsages(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postLotUsagesBegin())
		return fetch(`${URL}api/lotusages`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postLotUsagesSuccess(json))
			})
			.catch(catchApiError(dispatch, postLotUsagesError))
	}
}

// LimiteChecker

export const FETCH_ITEMCHECKER_BEGIN = "FETCH_ITEMCHECKER_BEGIN"
export const FETCH_ITEMCHECKER_SUCCESS = "FETCH_ITEMCHECKER_SUCCESS"
export const FETCH_ITEMCHECKER_ERROR = "FETCH_ITEMCHECKER_ERROR"

export const fetchItemCheckerBegin = () => ({
	type: FETCH_ITEMCHECKER_BEGIN,
})

export const fetchItemCheckerSuccess = (itemChecker) => ({
	type: FETCH_ITEMCHECKER_SUCCESS,
	payload: { itemChecker },
})

export const fetchItemCheckerError = (error) => ({
	type: FETCH_ITEMCHECKER_ERROR,
	payload: { error },
})

export function fetchItemChecker() {
	let url = `${URL}api/itemchecker`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchItemCheckerBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchItemCheckerSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchItemCheckerError))
	}
}
